import { getAccessToken } from 'lib/api/utils'

export const goToTeacherDashboard = (newTab = false) => {
  const accessToken = getAccessToken()
  const url = `/trustedapps?accessToken=${accessToken}`

  if (newTab) {
    window.open(url)
  } else {
    window.location.href = url
  }
}
